import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faHome,
  faFolderOpen,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  faTwitter,
  faGithub,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import "./Sidebar.css";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(() => window.innerWidth >= 769);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 769) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => setIsOpen((v) => !v);

  return (
    <>
      <aside className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <div className="sidebar-top">
          <button
            className="menu-toggle top-toggle"
            onClick={toggleMenu}
            aria-label="Close sidebar"
          >
            <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
          </button>
          <img className="avatar" src="/header-logo-dragon.png" alt="avatar" />
          <h2 className="site-title">Poul Zheng</h2>
        </div>

        <nav className="nav-links">
          <a href="/" className="nav-item">
            <FontAwesomeIcon icon={faHome} />
            <span>Home</span>
          </a>
          <a href="/projects" className="nav-item">
            <FontAwesomeIcon icon={faFolderOpen} />
            <span>Projects</span>
          </a>
          <a href="/certificates" className="nav-item">
            <FontAwesomeIcon icon={faFolderOpen} />
            <span>Certificates</span>
          </a>
          <a href="/contact" className="nav-item">
            <FontAwesomeIcon icon={faInfoCircle} />
            <span>Contact</span>
          </a>
        </nav>

        <div className="sidebar-bottom">
          <div className="socials">
            <a
              className="twitter"
              href="https://www.twitter.com/paulzheng_"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a
              className="github"
              href="https://www.github.com/dragon2462"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
            <a
              className="linkedin"
              href="https://www.linkedin.com/in/poul-zheng-022826181"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a
              className="instagram"
              href="https://www.instagram.com/paul.zheng_"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>
      </aside>

      <button
        className={`sidebar-handle ${isOpen ? "hidden" : "visible"}`}
        onClick={toggleMenu}
        aria-label="Open sidebar"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>
    </>
  );
};

export default Sidebar;
